'use strict';

function updateProgressBar ($bar, stats) {
  var checkedTotal;

  if (stats != null) {
    checkedTotal = stats.autochecked + stats.checked;
    $bar.find('.progress-label').text(checkedTotal + '/' + stats.all);
    $bar.find('.progress-bar').attr({
      'aria-valuemin': 0,
      'aria-valuenow': checkedTotal,
      'aria-valuemax': stats.all,
      'data-autochecked': stats.autochecked,
      'data-checked': stats.checked,
      'data-percent': stats.percent,
      'data-all': stats.all
    }).css('width', stats.percent + '%');
  }
}

module.exports = updateProgressBar;
